import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { UsersService } from '../services';

/**
 * React Query hook to fetch child offices by parent office ID
 *
 * @param {string} officeId - Parent office ID
 * @param {Object} [options] - Hook options
 * @param {boolean} [options.enabled=true] - Whether query should execute
 * @param {boolean} [options.refetchOnWindowFocus=false] - Refetch on window focus
 */
export const useGetChildOffices = (officeId, options) => {
  const dispatch = useDispatch();
  const enabled = options?.enabled ?? Boolean(officeId);

  const { data, error, isFetching, isLoading, isError } = useQuery({
    queryKey: ['GET_CHILD_OFFICES', officeId],
    queryFn: () => {
      dispatch({ type: 'GET_CHILD_OFFICES_REQUEST' });

      return UsersService.getChildOffices(officeId).finally(() =>
        dispatch({ type: 'GET_CHILD_OFFICES_SUCCESS' }),
      );
    },
    enabled,
    retry: false,
    refetchOnWindowFocus: options?.refetchOnWindowFocus ?? false,
  });

  return {
    data: data?.data || [],
    error,
    isError,
    isInitialLoading: isLoading,
    isLoading: isLoading || isFetching,
  };
};
